export default {
  firebaseConfig: {
    apiKey: "AIzaSyCVxIw0vKXvcV8iNfE9bhzL82-LGpY0sRY",
    authDomain: "bralife.firebaseapp.com",
    databaseURL: "https://bralife.firebaseio.com",
    projectId: "bralife",
    storageBucket: "",
    messagingSenderId: "14330746379",
    appId: "1:14330746379:web:0c3ccef4cb31f26e0e190e"
  }
};
